import axios from "axios";
import { getCookie } from "./CookieComponent";
import { decrypt, getEncodedCookie } from "./Reusable";

const URL = {
  // uatgogagnerurl: "https://vpsapi.xpertlab.com/gcc/v1/",
  uatgogagnerurl: "https://api.gcclawhelp.com/gcc/v1/",
};

// API HEADER
export const apiHeader = (isFormData) => {
  const apitoken = "8e413260076462658f63c4808c2ee682";
  // const token = "7a1080ab39d47c5bf4378f26b1e8e6";
  const token = decrypt(getCookie("token")) || "";

  if (!isFormData) {
    return {
      headers: {
        "x-token": token,
        apitoken: apitoken,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    };
  }

  if (isFormData) {
    return {
      headers: {
        "x-token": token,
        apitoken: apitoken,
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

// API CALL for POST method
export const postData = async (api, data, headers, showAlert = true) => {
  try {
    const url = `${URL.uatgogagnerurl}${api}`;

    const response = await axios.post(url, data, headers);

    return response;
  } catch (error) {
    console.log("error ==============++==+=======+==+", error.message);

    let networkError = error.message === "Network Error";
    return undefined;
  }
};

// API CALL for GET method
export const getData = async (api, params, headers, showAlert = true) => {
  try {
    const url = `${URL.uatgogagnerurl}${api}`;

    const response = await axios.get(url, {
      params: params,
      headers: headers["headers"],
    });

    return response;
  } catch (error) {
    console.log("Error:", error.message);

    let networkError = error.message === "Network Error";
    return undefined;
  }
};

export const getDataThirdParty = async (
  api,
  params,
  headers,
  showAlert = true
) => {
  try {
    const url = `${api}`;

    const response = await axios.get(url, {
      params: params,
      headers: headers["headers"],
    });

    return response;
  } catch (error) {
    console.log("Error:", error.message);

    let networkError = error.message === "Network Error";
    return undefined;
  }
};

// API CALL for PATCH method
export const patchData = async (api, data, headers, showAlert = true) => {
  try {
    const url = `${URL.uatgogagnerurl}${api}`;
    console.log("data=--=-=-=-=", data);

    const response = await axios.patch(url, data, headers);

    return response;
  } catch (error) {
    console.log("Error:", error.message);

    let networkError = error.message === "Network Error";
    return undefined;
  }
};

// API CALL for DELETE method
export const deleteData = async (api, data, headers, showAlert = true) => {
  try {
    const url = `${URL.uatgogagnerurl}${api}`;

    const response = await axios.delete(url, {
      data,
      ...headers,
    });

    return response;
  } catch (error) {
    console.log("Error:", error.message);

    let networkError = error.message === "Network Error";
    return undefined;
  }
};
